import {
  TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  TREQUEST_UPDATE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
  TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TFactoryProductLineEfficiencyActionType } from './product-line-efficiency.models';
export class GetFactoryProductLineEfficiency implements Action {
  readonly type = TFactoryProductLineEfficiencyActionType.GetFactoryProductLineEfficiency;
  constructor(public factoryId: string, public payload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY) {}
}

export class GetFactoryProductLineEfficiencySuccess implements Action {
  readonly type = TFactoryProductLineEfficiencyActionType.GetFactoryProductLineEfficiencySuccess;
  constructor(public factoryProductLineEfficiencyRes: TRESPONSE_FACTORY_PRODUCT_LINE_EFFICIENCY) {}
}

export class GetFactoryProductLineEfficiencyFailure implements Action {
  readonly type = TFactoryProductLineEfficiencyActionType.GetFactoryProductLineEfficiencyFailure;
  constructor() {}
}

export class DeleteFactoryProductLineEfficiency implements Action {
  readonly type = TFactoryProductLineEfficiencyActionType.DeleteFactoryProductLineEfficiency;
  constructor(
    public factoryId: string,
    public deletePayload: TREQUEST_DELETE_FACTORY_PRODUCT_LINE_EFFICIENCIES,
    public fetchPayload: TREQUEST_FACTORY_PRODUCT_LINE_EFFICIENCY,
  ) {}
}

export class DeleteFactoryProductLineEfficiencyFailure implements Action {
  readonly type = TFactoryProductLineEfficiencyActionType.DeleteFactoryProductLineEfficiencyFailure;
  constructor() {}
}

export type TFactoryProductLineEfficiencyActions =
  | GetFactoryProductLineEfficiency
  | GetFactoryProductLineEfficiencySuccess
  | GetFactoryProductLineEfficiencyFailure
  | DeleteFactoryProductLineEfficiency
  | DeleteFactoryProductLineEfficiencyFailure;
